import { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

const Home = lazy(() => import("@/pages/Home"));
const Services = lazy(() => import("@/pages/Services"));
const Drainage = lazy(() => import("@/pages/services/Drainage"));
const Drainlaying = lazy(() => import("@/pages/services/Drainlaying"));
const DrainUnblocking = lazy(() => import("@/pages/services/DrainUnblocking"));
const RainwaterTankInstall = lazy(() => import("@/pages/services/RainwaterTankInstall"));
const WastewaterSystems = lazy(() => import("@/pages/services/WastewaterSystems"));
const EarthworksDemolition = lazy(() => import("@/pages/services/EarthworksDemolition"));
const ConcreteCivil = lazy(() => import("@/pages/services/ConcreteCivil"));
const Plumbing = lazy(() => import("@/pages/services/Plumbing"));
const About = lazy(() => import("@/pages/About"));
const Testimonials = lazy(() => import("@/pages/Testimonials"));
const Contact = lazy(() => import("@/pages/Contact"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const NotFound = lazy(() => import("@/pages/NotFound"));

// Service Areas
const Hillsborough = lazy(() => import("@/pages/service-areas/Hillsborough"));
const Onehunga = lazy(() => import("@/pages/service-areas/Onehunga"));
const MountRoskill = lazy(() => import("@/pages/service-areas/MountRoskill"));
const SouthAuckland = lazy(() => import("@/pages/service-areas/SouthAuckland"));
const WestAuckland = lazy(() => import("@/pages/service-areas/WestAuckland"));

export default function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Suspense fallback={<div className="min-h-[40vh]" />}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/drainage" element={<Drainage />} />
          <Route path="/services/public-drainage" element={<Drainage />} />
          <Route path="/services/private-drainage" element={<Drainage />} />
          <Route path="/services/rainwater-tank-install" element={<RainwaterTankInstall />} />
          <Route path="/services/wastewater-systems" element={<WastewaterSystems />} />
          <Route path="/services/drainlaying" element={<Drainlaying />} />
          <Route path="/services/drain-unblocking" element={<DrainUnblocking />} />
          <Route path="/services/earthworks-demolition" element={<EarthworksDemolition />} />
          <Route path="/services/concrete-civil" element={<ConcreteCivil />} />
          <Route path="/services/plumbing" element={<Plumbing />} />
          
          {/* Service Areas */}
          <Route path="/service-areas/central-isthmus/hillsborough" element={<Hillsborough />} />
          <Route path="/service-areas/central-isthmus/onehunga" element={<Onehunga />} />
          <Route path="/service-areas/central-isthmus/mt-roskill" element={<MountRoskill />} />
          <Route path="/service-areas/central-isthmus/mount-roskill" element={<MountRoskill />} />
          <Route path="/service-areas/south-auckland/papakura-drury" element={<SouthAuckland />} />
          <Route path="/service-areas/south-auckland" element={<SouthAuckland />} />
          <Route path="/service-areas/west-auckland/new-lynn-henderson" element={<WestAuckland />} />
          <Route path="/service-areas/west-auckland" element={<WestAuckland />} />

          <Route path="/about" element={<About />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </AnimatePresence>
  );
}
